import React, { useEffect } from 'react';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import { FullAccount } from '../../../redux/Account/account.selectors';
import { App } from '../../../App';
import { SmartContainer, Stack, StyledGridItem, Surface } from '../../../styles/Containers';
import { NewContent } from '../../../components/Content/NewContent';
import { FullLibraries } from './redux/library.selectors';
import { createLibrary, restoreLibrary } from './redux/library.actions';
import { TopLevelNavigation } from '../../components/Dashboard/TopLevelNavigation';
import { Role } from '../../../redux/Auth/auth.selectors';
import { PayWall } from '../../../components/Billing/PayWall';
import { validPlans } from '../../../config';
import { LibraryList } from './LibraryList';
import { TERM_LIBRARY } from '../../services/CaptureCollabService';
export const PageLibaries = () => {

    const dispatch = useDispatch();
    const fullAccount = FullAccount();
    const store = FullLibraries();
    const currentUserRole = Role();

    // --------------------------
    // Effects
    // --------------------------

    useEffect(() => { if (store.createSuccess) dispatch(push(`/library/${store.create.id}/upload`)) }, [store?.createLoading])

    // --------------------------
    // Interactions
    // --------------------------

    const handleSelect = (item) => {

        if (item?.full?.deletedAt) dispatch(restoreLibrary(item.id))
        else dispatch(push(`/library/${item.id}`))
    }

    const renderTopBarChildren = () => {

        // if (!hasAccess('library')) return;

        // Hide Library Create if Not and Admin or Editor.
        if (currentUserRole !== 'owner' && currentUserRole !== 'admin') return null;

        return (
            <SmartContainer flex align="center" justify="flex-end">
                <NewContent buttonText={`New ${TERM_LIBRARY}`} label={`New ${TERM_LIBRARY}`} selector={FullLibraries} createAction={createLibrary} />
            </SmartContainer>
        )

    }
    const renderPageNavigation = () => {
        return (<TopLevelNavigation />)
    }

    const renderNewLibrary = () => {
        if (currentUserRole !== 'owner' && currentUserRole !== 'admin') return null;
        return (
            <StyledGridItem key="newlibrary">
                <Surface flex justify="center" align="center" width="100%">
                    <NewContent iconHelperText={`New ${TERM_LIBRARY}`} label={`New ${TERM_LIBRARY}`} selector={FullLibraries} createAction={createLibrary} />
                </Surface>
            </StyledGridItem>
        )
    }

    const renderLibraryBar = () => {

        // Hide Library Create if Not and Admin or Editor.
        if (currentUserRole !== 'owner' && currentUserRole !== 'admin') return null;

        return (
            <SmartContainer flex align="center" justify="flex-end">
                <NewContent buttonText={`New ${TERM_LIBRARY}`} label={`New ${TERM_LIBRARY}`} selector={FullLibraries} createAction={createLibrary} />
            </SmartContainer>
        )

    }

    return (
        <App pageNavigation={renderPageNavigation} topBarChildren={renderLibraryBar()}>

            <Stack>

                <PayWall plans={validPlans} title="It's time to upgrade your account">

                    <LibraryList onSelect={handleSelect} />
                </PayWall>

            </Stack>

        </App>
    )
}